{
  "name": "user-menu-web",
  "version": "0.2.0",
  "private": true,
  "engines": {
    "node": "^22.22.2 || ^24.15.0 || >=26.0.0",
    "npm": ">10"
  },
  "type": "module",
  "scripts": {
    "start": "vite",
    "build": "vite build && rimraf build/mockServiceWorker.js",
    "preview": "vite preview",
    "test": "tsc -b && vitest run",
    "test-ci": "npm run test -- --reporter=junit --outputFile.junit=./results/junit.xml",
    "test-dev": "vitest",
    "coverage": "vitest run --coverage",
    "ci-install": "PUPPETEER_SKIP_CHROMIUM_DOWNLOAD=true npm install",
    "lint": "biome check .",
    "lint-fix": "biome check --write .",
    "format-code": "biome format --write .",
    "format-code-on-commit": "npm run format-code && git add",
    "audit": "npm audit --registry https://registry.npmjs.org --parseable --omit=dev",
    "playwright-test": "playwright test",
    "playwright-open": "playwright test --ui",
    "msw-init": "msw init public --save=false",
    "playwright-install": "playwright install --with-deps chromium",
    "playwright-setup": "npm run msw-init && npm run playwright-install",
    "rio-license-checker": "rio-license-checker",
    "i18n-flow": "i18n-flow"
  },
  "dependencies": {
    "@reduxjs/toolkit": "2.13.0",
    "@rio-cloud/rio-session-expired-info": "2.0.0",
    "@rio-cloud/rio-uikit": "3.0.1",
    "@sentry/browser": "11.10.0",
    "iframe-resizer": "4.3.11",
    "lodash": "4.18.1",
    "oidc-client-ts": "3.5.0",
    "react": "19.3.1",
    "react-dom": "19.3.1",
    "react-intl": "12.1.6",
    "react-redux": "9.3.1"
  },
  "devDependencies": {
    "@biomejs/biome": "2.6.4",
    "@playwright/test": "1.64.1",
    "@rio-cloud/i18n": "1.0.0",
    "@rio-cloud/rio-license-checker": "1.3.1",
    "@rio-cloud/vite-plugin-frontend-license-check": "3.1.1",
    "@testing-library/dom": "10.4.2",
    "@testing-library/jest-dom": "7.0.1",
    "@testing-library/react": "16.3.3",
    "@testing-library/user-event": "14.6.8",
    "@types/lodash": "4.17.27",
    "@types/node": "24.19.2",
    "@types/react": "19.3.0",
    "@types/react-dom": "19.3.0",
    "@types/react-redux": "7.1.35",
    "@vitejs/plugin-react": "6.1.2",
    "events": "3.3.0",
    "jsdom": "30.1.3",
    "msw": "3.0.3",
    "rimraf": "6.1.3",
    "rollup-plugin-visualizer": "7.1.1",
    "typescript": "5.9.3",
    "vite": "8.3.5",
    "vitest": "5.0.5"
  },
  "browserslist": [
    "last 5 Chrome versions",
    "Firefox >= 147",
    "last 5 Edge versions",
    "Safari >= 26"
  ],
  "msw": {
    "workerDirectory": "public"
  },
  "overrides": {
    "moment": ">2.30.1"
  }
}
